import { useQuery, useQueryClient } from '@tanstack/react-query';

import { getConnection } from '@/lib/solana/anchorClient';
import { getGlobalConfigAccount } from '@/lib/solana/accounts';

export function useGlobalConfig() {
  const queryClient = useQueryClient();

  const {
    data: globalConfig,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['globalConfig'],
    queryFn: async () => {
      const connection = getConnection();
      const config = await getGlobalConfigAccount(connection);
      if (!config) {
        throw new Error('GlobalConfig not found - program may not be initialized');
      }
      return config;
    },
    staleTime: 60 * 1000, // Cache for 1 minute since config rarely changes
    refetchOnWindowFocus: false,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: ['globalConfig'] });
  };

  return {
    globalConfig,
    isLoading,
    error,
    refetch,
    invalidate,
  };
}